import { PackTypes } from "illuminate/types";
export const PACKS_TABLE_ID = "packsTable";
export const ATTRIBUTES = [
  {
    id: "title",
    title: "Pack Name",
    type: "STRING",
    searchable: true
  },
  {
    id: "enabled",
    title: "State",
    type: "STRING",
    filterable: true,
    filter_options: [
      { value: "true", title: "Enabled" },
      { value: "false", title: "Disabled" }
    ]
  },
  {
    id: "status",
    title: "Status",
    type: "STRING",
    filterable: true,
    filter_options: [
      { value: "new", title: "New" },
      { value: "update", title: "Updated" }
    ]
  },
  {
    id: "type",
    title: "Type",
    type: "STRING",
    filterable: true,
    filter_options: [
      { value: PackTypes.SPOTLIGHT, title: "Spotlight" },
      { value: PackTypes.PROCESSING, title: "Processing" }
    ]
  },
  {
    id: "included_in_bundle",
    title: "Availability",
    type: "BOOLEAN",
    filterable: true,
    filter_options: [
      { value: "true", title: "Licensed" },
      { value: "false", title: "Unlicensed" }
    ]
  },
  {
    id: "pack_id",
    title: "Pack ID",
    type: "STRING"
  }
];
export const packsTableElements = {
  defaultLayout: {
    entityTableId: PACKS_TABLE_ID,
    defaultPageSize: 20,
    defaultSort: { attributeId: "is_new", direction: "asc" },
    defaultDisplayedAttributes: ["title", "enabled", "status", "type", "included_in_bundle"],
    defaultColumnOrder: ["title", "included_in_bundle", "enabled", "status", "type", "category", "pack_id"]
  }
};
